import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { settings } from './components/remoteData/APISettings';
import { AuthProvider } from './components/remoteData/authProvider';
import { MsalProvider } from '@azure/msal-react';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const apiSettings = await settings;
const auth = AuthProvider(apiSettings);

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <MsalProvider instance={auth}>
      <BrowserRouter basename={baseUrl}>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
